<template>
  <div
    v-show="show"
    class="modal fade"
    :class="[
      { 'show d-block': show },
      { 'd-none': !show },
      { 'modal-mini': type === 'mini' },
    ]"
    tabindex="-1"
    dialog="dialog"
    :aria-hidden="!show"
    @mousedown.self="closeModal"
  >
    <div
      class="modal-dialog modal-dialog-centered model-center"
      :class="[
        { 'modal-notice': type === 'notice', [`modal-${size}`]: size },
        modalClasses,
      ]"
    >
      <div
        class="modal-content"
        :class="[
          gradient ? `bg-gradient-${gradient}` : '',
          modalContentClasses,
        ]"
      >
        <div v-if="$slots.header" class="modal-header" :class="[headerClasses]">
          <slot name="header" class="p-2"></slot>
          <slot name="close-button">
            <button
              v-if="showClose"
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="closeModal"
            ></button>
          </slot>
        </div>

        <div class="modal-body" :class="bodyClasses">
          <slot></slot>
        </div>

        <div v-if="$slots.footer" class="modal-footer" :class="footerClasses">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Modal",
  props: {
    show: Boolean,
    showClose: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: "",
      validator(value) {
        let acceptedValues = ["", "notice", "mini"];
        return acceptedValues.indexOf(value) !== -1;
      },
      description: 'Modal type (notice|mini|"") ',
    },
    // eslint-disable-next-line vue/require-default-prop
    modalClasses: {
      type: [Object, String],
      description: "Modal dialog css classes",
    },
    size: {
      type: String,
      description: "Modal size",
      default: "",
      validator(value) {
        let acceptedValues = ["", "sm", "lg", "xl"];
        return acceptedValues.indexOf(value) !== -1;
      },
    },
    // eslint-disable-next-line vue/require-default-prop
    modalContentClasses: {
      type: [Object, String],
      description: "Modal dialog content css classes",
    },
    // eslint-disable-next-line vue/require-default-prop
    gradient: {
      type: String,
      description: "Modal gradient type (danger, primary etc)",
    },
    // eslint-disable-next-line vue/require-default-prop
    headerClasses: {
      type: [Object, String],
      description: "Modal Header css classes",
    },
    // eslint-disable-next-line vue/require-default-prop
    bodyClasses: {
      type: [Object, String],
      description: "Modal Body css classes",
    },
    // eslint-disable-next-line vue/require-default-prop
    footerClasses: {
      type: [Object, String],
      description: "Modal Footer css classes",
    },
    animationDuration: {
      type: Number,
      default: 500,
      description: "Modal transition duration",
    },
  },
  emits: ["update:show", "close"],
  watch: {
    show(val) {
      let documentClasses = document.body.classList;
      if (val) {
        documentClasses.add("modal-open");
      } else {
        documentClasses.remove("modal-open");
      }
    },
  },
  methods: {
    closeModal() {
      this.$emit("update:show", false);
      this.$emit("close");
      this.$parent.closeModal();
    },
  },
};
</script>
<style>
.modal.show {
  background-color: rgba(0, 0, 0, 0.5);
}
.model-large {
  height:50rem !important;
  min-width:50rem;
}
.model-center {
  /* margin-left: 22rem !important; */
}
.workout-intense-model {
  min-height: 50rem !important;
  min-width: 65rem;
}
.sleep-intense-model {
  min-height: 50rem !important;
  min-width: 68rem;
}
.challenge-details-model {
  min-height: 40rem !important;
  min-width: 70rem;
}
</style>
